import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Autocolor } from '../models/autocolor';
import { Formula } from '../models/formula';
import { FormulaColor } from '../models/formulacolor';
import { FormulaService } from '../services';

@Component({
  selector: 'app-detalle-color',
  templateUrl: './detalle-color.component.html',
  styleUrls: ['./detalle-color.component.css']
})
export class DetalleColorComponent implements OnInit {

  formulaColor: FormulaColor;
  autocolor: Autocolor;
  formula: Formula;
  subformulas: Formula[];
  idformulaActual: string;
  idcolorActual: number;
  idSistemaActual: number;


  collapsed: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private formulaService: FormulaService,
    private location: Location
  ) { }

  ngOnInit(): void {
    this.collapsed = false
    this.llenarObjetos();
  }

  llenarObjetos(): void {
    this.idformulaActual = this.route.snapshot.paramMap.get('idformula');
    this.idcolorActual = + this.route.snapshot.paramMap.get('idcolor');
    this.idSistemaActual = +this.route.snapshot.paramMap.get('idsistema');

    this.formulaService.getFormulaColorById(this.idSistemaActual, this.idformulaActual, this.idcolorActual)
      .subscribe(fc => {
        this.formulaColor = fc;
        this.autocolor = fc.autocolor
        this.formula = fc.formula;

/* 
        this.subformulas = this.formula.subformulas; */


      });
  }

  goBack(): void {
    this.location.back();
  }

/*   downloadFile(): void {
    const filename = 'prueba.pdf'
    this.fcService
      .imprimirFormulasColor(this.idformulaActual)
      .subscribe(blob => saveAs(blob, filename));
  } */

}
